import UserConsent from "../mobile/capacitorPlugins";
import { FirebaseAnalytics } from "@capacitor-community/firebase-analytics";

async function showMobileConsent(appConfig, serverData, lastLocale) {
	if(!appConfig.mobile.isMobileApp()) {
		return;
	}

	const isNativeConsentEnabled = window.TENANT_MAPPING_DATA.thirdPartyScriptRules[appConfig.tenantId].mobileApp.includes("NATIVE_COOKIE_CONSENTS");
	if (isNativeConsentEnabled && serverData && serverData.mobileConsentSdk) {
		await UserConsent.show({ ...serverData.mobileConsentSdk, isInitial: true, languageCode: lastLocale.toUpperCase() });
		localStorage.setItem("user_consent_triggered", "true");
		FirebaseAnalytics.setCollectionEnabled({enabled: true});
	}
}

export {showMobileConsent};
